import React from "react";
import Dashboard from "./Dashboard";
import SalesExecDashboard from "./SalesExecDashboard";

/**
 * DashboardRouter conditionally renders the appropriate dashboard
 * based on the logged-in user's position_id.
 *
 * position_id 73 → Sales Executive Dashboard
 * All others   → Admin / Management Dashboard
 */
function DashboardRouter() {
  return <SalesExecDashboard />;
}

export default DashboardRouter;
